import { render, staticRenderFns } from "./PsCalendarDialogNewEvent.vue?vue&type=template&id=2e3d6eec&scoped=true&"
import script from "./PsCalendarDialogNewEvent.vue?vue&type=script&lang=js&"
export * from "./PsCalendarDialogNewEvent.vue?vue&type=script&lang=js&"
import style0 from "./PsCalendarDialogNewEvent.vue?vue&type=style&index=0&id=2e3d6eec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3d6eec",
  null
  
)

export default component.exports